export const eventSummary = [
  {
    label: 'Customer Name',
    content: 'Lorem ipsum'
  },
  {
    label: 'Contact Phone',
    content: 'Lorem ipsum'
  },
  {
    label: 'Contact Email',
    content: 'Lorem ipsum'
  },
  {
    label: 'EyeMed associate',
    content: 'Lorem ipsum'
  },
  {
    label: 'Event Date',
    content: 'Lorem ipsum'
  },
  {
    label: 'Ship to event',
    content: 'Lorem ipsum'
  },
  {
    label: 'Start time',
    content: 'Lorem ipsum'
  },
  {
    label: 'End Time',
    content: 'Lorem ipsum'
  },
  {
    label: 'Spanish Benefit Translation',
    content: 'Lorem ipsum'
  },
  {
    label: 'Deliver By',
    content: 'Lorem ipsum'
  },
  {
    label: 'Shipping Line 1',
    content: 'Lorem ipsum'
  },
  {
    label: 'Shipping Line 2',
    content: 'Lorem ipsum'
  },
  {
    label: 'Shipping Zip Code',
    content: 'Lorem ipsum'
  },
  {
    label: 'Spanish Quantity',
    content: 'Lorem ipsum'
  },
  {
    label: 'Shipping State',
    content: 'Lorem ipsum'
  },
  {
    label: 'Employee Packets',
    content: 'Lorem ipsum'
  },
  {
    label: 'Packet Quantity',
    content: 'Lorem ipsum'
  },
  {
    label: 'Shipping City',
    content: 'Lorem ipsum'
  },
  {
    label: 'EyeMed Associate Name',
    content: 'Lorem ipsum'
  }
]
